/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  browse: {
    name: 'browse-and-search',
    componentName: 'BrowseAndSearchContainer',
    chunk: () => import(
      /* webpackChunkName: "browse-and-search" */
      './pages/browse-search/BrowseAndSearchContainer.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchContainer.js')).BrowseAndSearchContainer
        : currentRouteName === 'browse-and-search'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchContainer })))
    },
    path: '/:context?/b',
    prefetch: ['product', 'package'],
    channel: 'desktop'
  },

  browseMobile: {
    name: 'browse-and-search-mobile',
    componentName: 'BrowseAndSearchMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "browse-and-search-mobile" */
      './pages/browse-search/BrowseAndSearchMobileContainer.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchMobileContainer.js')).BrowseAndSearchMobileContainer
        : currentRouteName === 'browse-and-search-mobile'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchMobileContainer })))
    },
    path: '/:context?/b',
    prefetch: ['productMobile', 'package'],
    channel: 'mobile'
  },

  search: {
    name: 'browse-and-search',
    componentName: 'BrowseAndSearchContainer',
    chunk: () => import(
      /* webpackChunkName: "browse-and-search" */
      './pages/browse-search/BrowseAndSearchContainer.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchContainer.js')).BrowseAndSearchContainer
        : currentRouteName === 'browse-and-search'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchContainer })))
    },
    path: '/:context?/s',
    prefetch: ['product', 'package'],
    channel: 'desktop'
  },

  searchMobile: {
    name: 'browse-and-search-mobile',
    componentName: 'BrowseAndSearchMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "browse-and-search-mobile" */
      './pages/browse-search/BrowseAndSearchMobileContainer.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchMobileContainer.js')).BrowseAndSearchMobileContainer
        : currentRouteName === 'browse-and-search-mobile'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchMobileContainer })))
    },
    path: '/:context?/s',
    prefetch: ['productMobile', 'package'],
    channel: 'mobile'
  },

  package: {
    name: 'package',
    componentName: 'PackageContainer',
    chunk: () => import(
      /* webpackChunkName: "package" */
      './pages/package/PackageContainer.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/package/PackageContainer.js')).PackageContainer
        : currentRouteName === 'package'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PackageContainer })))
    },
    path: '/:context?/p/sets/:seo1?/:seo2?/:slug?/:packageId',
    prefetch: ['browse', 'product'],
    channel: null
  },

  product: {
    name: 'product',
    componentName: 'ProductContainer',
    chunk: () => import(
      /* webpackChunkName: "product" */
      './pages/product/ProductContainer.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/product/ProductContainer.js')).ProductContainer
        : currentRouteName === 'product'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductContainer })))
    },
    path: '/:context?/p/:slug?/:itemId',
    prefetch: ['browse', 'package'],
    channel: 'desktop'
  },

  productMobile: {
    name: 'product-mobile',
    componentName: 'ProductMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "product-mobile" */
      './pages/product/ProductMobileContainer.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/product/ProductMobileContainer.js')).ProductMobileContainer
        : currentRouteName === 'product-mobile'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductMobileContainer })))
    },
    path: '/:context?/p/:slug?/:itemId',
    prefetch: ['browseMobile', 'package'],
    channel: 'mobile'
  },

  compare: {
    name: 'compare',
    componentName: 'CompareContainer',
    chunk: () => import(
      /* webpackChunkName: "compare" */
      './pages/compare/CompareContainer.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/compare/CompareContainer.js')).CompareContainer
        : currentRouteName === 'compare'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CompareContainer })))
    },
    path: '/:context?/compare',
    channel: null
  },

  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "home" */
      './pages/Home.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })))
    },
    path: '/:context?/',
    channel: null
  }
});
